module.exports = __webpack_public_path__ + "img/hopital_chinois.f6607606.webp";